import React from 'react';

import { SettingsPageHeader } from './SettingsPageHeader';

interface SettingsPageColumnProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

/**
 * The single centered column every settings page sits in. The title comes in
 * as a prop so the shell can read it from the registry; pages only pass their
 * groups and cards.
 */
export const SettingsPageColumn = ({
  title,
  description,
  children,
}: SettingsPageColumnProps) => (
  <div className="mx-auto box-border w-full max-w-[760px] px-5 pt-16 pb-20 lg:px-10">
    <SettingsPageHeader title={title} description={description} />
    {children && <div className="mt-10 flex flex-col gap-10">{children}</div>}
  </div>
);
